module.exports = __webpack_public_path__ + "static/media/description-logo-fr.6137ff67.png";